import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVideoOff: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconVideoOff"><Path d="M18.4055 21.6703L2.67177 1.59619L1.09766 2.82995L2.01481 4.00012H2.00159V20.0001H14.5554L16.8314 22.9041L18.4055 21.6703Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M7.09704 4.00012L16.3329 15.7838L22.0016 18.6181V5.38208L16.0016 8.38208V4.00012H7.09704ZM16.0016 13.3821L20.0016 15.3821V8.61815L16.0016 10.6181V13.3821Z" fill="currentColor"/></CentralIconBase>;
});

export default IconVideoOff;
